import { t } from '@/ui/i18n/i18n';
import { renderResourceTeaserPage } from '@/ui/pages/teasers/ResourceTeaserPage';
import { TeaserRoutes } from '@/ui/routes/types';

export const renderAnalyticsTeaserPage = (
  title = t('common.analytics'),
  message = t('analytics.teaser'),
  teaser = t('common.teaser'),
  routeName: TeaserRoutes = 'analytics',
) =>
  renderResourceTeaserPage(title, message, teaser, routeName)();
